module.exports = __webpack_public_path__ + "img/progress_081.bfe745a5.png";